import type { EmbarcacaoEquipamentosField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const EQUIPAMENTOS_ID = "equipamentos";
export const EQUIPAMENTOS_TITLE = "Equipamentos";
export const EQUIPAMENTOS_TEST_ID = "embarcacao-equipamentos";
export const EQUIPAMENTOS_LOADING_MESSAGE = "Carregando os Equipamentos da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const EQUIPAMENTOS_EMPTY_STATE = {
  title: "Nenhuma informação de Equipamentos disponível",
  description:
    "Assim que houver dados de Fi-Fi e Watermaker desta embarcação, eles aparecerão nesta seção.",
};

/** Os 6 campos, na ordem da HU; a unidade de medida fica no rótulo. */
export const EQUIPAMENTOS_FIELDS: DetailFieldDefinition<EmbarcacaoEquipamentosField>[] = [
  { key: "possuiEstruturaFiFi", label: "Possui estrutura de Fi-Fi?" },
  { key: "fiFiFuncionando", label: "Fi-Fi funcionando?" },
  { key: "possuiWatermaker", label: "Possui Watermaker?" },
  { key: "capacidadeWatermaker", label: "Capacidade Watermaker (m³/dia)" },
  { key: "watermakerOperacional", label: "Watermaker Operacional" },
  {
    key: "atualizacaoEquipamentos",
    label: "Data Atualização Equipamentos",
    format: formatDetailDate,
  },
];
